export default __webpack_public_path__ + "static/media/frame-5.fe39a417.png";